import {
    createEntityAdapter,
    createSelector,
    createSlice,
    PayloadAction,
} from '@reduxjs/toolkit'
import { RootState } from './store'

type SchoolEventReadEntity = {
    id: string
    status: boolean
    // If read => true, if dismissed => false.
    // NOTE: We can come back to revise this structure
}

const schoolEventReadsAdapter = createEntityAdapter<SchoolEventReadEntity>({
    selectId: (e) => e.id,
})

export const initialState = schoolEventReadsAdapter.getInitialState()

export const schoolEventReadsSlice = createSlice({
    name: 'schoolEventReads',
    initialState,
    reducers: {
        upsertSchoolEventReads: (
            state,
            action: PayloadAction<SchoolEventReadEntity[]>
        ) => {
            schoolEventReadsAdapter.upsertMany(state, action.payload)
        },
        upsertSchoolEventRead: (
            state,
            action: PayloadAction<SchoolEventReadEntity>
        ) => {
            schoolEventReadsAdapter.upsertOne(state, action.payload)
        },

        removeSchoolEventRead: (state, action: PayloadAction<string>) => {
            schoolEventReadsAdapter.removeOne(state, action.payload)
        },
        resetSchoolEventReads: () => {
            return initialState
        },
    },
})

export const {
    selectById: selectSchoolEventReadById,
    selectAll: selectAllSchoolEventReads,
    selectIds: selectSchoolEventReadIds,
} = schoolEventReadsAdapter.getSelectors(
    (state: RootState) => state.schoolEventReads
)

export const makeSelectSchoolEventReadById = () =>
    createSelector(
        [(state: RootState) => state, (_, id) => id],
        (state, id) => selectSchoolEventReadById(state, id) !== undefined
    )

export const {
    upsertSchoolEventReads,
    upsertSchoolEventRead,
    removeSchoolEventRead,
    resetSchoolEventReads,
} = schoolEventReadsSlice.actions
export default schoolEventReadsSlice.reducer
